import { invokeApi } from "../Utils/InvokeApi";
import { invokeApi2 } from "../Utils/InvokeApi2";
import { invokeApi3 } from "../Utils/InvokeApi3";
export const updateAdminData = async (id, data) => {
  const reqObj = {
    path: `/user/admin/update/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updatePermision = async (id, data) => {
  const reqObj = {
    path: `/permission/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const setPk = async (data) => {
  const reqObj = {
    path: `/create-pk`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateCategory = async (id, data) => {
  const reqObj = {
    path: `/update-product-categories/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateRcoin = async (id, data) => {
  const reqObj = {
    path: `/user/send-rcoin/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateUserStatus = async (id, data) => {
  const reqObj = {
    path: `/user/ban-user/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateBanUser = async (data) => {
  const reqObj = {
    path: `/image/user-ban-proof`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateUnBanUser = async (id) => {
  const reqObj = {
    path: `/user/unban-user/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const updatePk = async (id, data) => {
  const reqObj = {
    path: `/update-pk/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateTag = async (id, data) => {
  const reqObj = {
    path: `/update-live-stream-tag/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateAgency = async (id, data) => {
  const reqObj = {
    path: `/agency/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateAgencyStatus = async (id, data) => {
  const reqObj = {
    path: `/agency/change-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};

export const updateGiftData = async (id, data) => {
  const reqObj = {
    path: `/gift/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateStatusData = async (data, id) => {
  const reqObj = {
    path: `/business-developer/change-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi3(reqObj);
};
export const updateSenderData = async (data, id) => {
  const reqObj = {
    path: `/update-sender-level-info/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateHostData = async (data, id) => {
  const reqObj = {
    path: `/update-host-level-info/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateDiamondsPackage = async (id, data) => {
  const reqObj = {
    path: `/package/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateFamilyStatus = async (id, data) => {
  const reqObj = {
    path: `/update-family/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateMerchantStatus = async (id, data) => {
  const reqObj = {
    path: `/change-merchant-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateFamilyData = async (id, data) => {
  const reqObj = {
    path: `/family/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateImageBubbleData = async (id, data) => {
  const reqObj = {
    path: `/update-text-bubble/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateImageData = async (id, data) => {
  const reqObj = {
    path: `/image/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const updateSingleSpecialRIDData = async (id, data) => {
  const reqObj = {
    path: `/update-special-rid/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateSingleProductData = async (id, data) => {
  const reqObj = {
    path: `/update-product/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateCustomerData = async (id, data) => {
  const reqObj = {
    path: `/update-customer-support/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateResellerAPI = async (id, data) => {
  const reqObj = {
    path: `/update-reseller/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateSingleCutomerData = async (id, data) => {
  const reqObj = {
    path: `/update-product/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateProfileTags = async (id, data) => {
  const reqObj = {
    path: `/update-profile-tag/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateAssignTagsData = async (id, data) => {
  const reqObj = {
    path: `/update-assign-stream-tag/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateProdileAssignTagsData = async (id, data) => {
  const reqObj = {
    path: `/update-user-tag/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateAssignLevelData = async (id, data) => {
  const reqObj = {
    path: `/update-sender-assign-level/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateAssignHostLevelData = async (id, data) => {
  const reqObj = {
    path: `/update-host-assign-level/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateSingleMerchandData = async (id, data) => {
  const reqObj = {
    path: `/update-merchant/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateWithdrawPayment = async (id, data) => {
  const reqObj = {
    path: `/update-payment-method/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateBannerData = async (id, data) => {
  const reqObj = {
    path: `/update-banner/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateResellerStatus = async (id, data) => {
  const reqObj = {
    path: `/change-reseller-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateFamilyRule = async (id, data) => {
  const reqObj = {
    path: `/update-family-new-rule/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssignChat = async (id, data) => {
  const reqObj = {
    path: `/assign-support-member/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssingnDeactive = async (id) => {
  const reqObj = {
    path: `/reactive-user/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    // postData: data,
  };
  return invokeApi2(reqObj);
};
